import "./index.scss";

import { Box } from "@mui/material";
import Button from "components/Button";
import ScreenLoader from "components/ScreenLoader";
import StaffsAddEditComp from "components/StaffsAddEdit";
import Tabs from "components/Tabs";
import { appActions } from "modules/app";
import { getStaffDetails } from "modules/staffs/staffServices";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch } from "redux/hooks";

import AssignedMembers from "./AssignedMembers";
import PersonalDetails from "./PersonalDetails";

function StaffDetails() {
  const dispatch = useAppDispatch();
  const [tabValue, setTabValue] = useState<number>(0);
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [showStaffAddEditModal, setShowStaffAddEditModal] = useState<boolean>(false);

  useEffect(() => {
    if (details)
      dispatch(
        appActions.updatePageTitle({ title: `${details?.first_name} ${details.last_name}` })
      );
    else dispatch(appActions.updatePageTitle({ title: `` }));
  }, [details]);

  useEffect(() => {
    fetchStaffDetails(id);
  }, [id]);

  const fetchStaffDetails = async (staffId) => {
    setLoading(true);
    let result = await getStaffDetails(staffId);
    setLoading(false);
    if (result.success) {
      setDetails(result.data);
    } else {
      toast(result.message, { type: "error" });
    }
  };

  return (
    <Box className="staff-details-container">
      {loading ? (
        <Box my="20px">
          <ScreenLoader isScreenLoader />
        </Box>
      ) : (
        <>
          <Tabs
            value={tabValue}
            onChange={setTabValue}
            tabs={[{ label: "Personal Details" }, { label: "Assigned Members" }]}
            rightComp={
              tabValue === 0 ? (
                <Button
                  onClick={() => setShowStaffAddEditModal(true)}
                  label={"Edit"}
                  color={"primary-green"}
                />
              ) : (
                <></>
              )
            }
          />
          {tabValue === 0 && <PersonalDetails data={details} />}

          {tabValue === 1 && <AssignedMembers staff={details} />}
        </>
      )}
      {showStaffAddEditModal && (
        <StaffsAddEditComp
          open={showStaffAddEditModal}
          data={details}
          onClose={() => {
            setShowStaffAddEditModal(false);
          }}
          callback={() => fetchStaffDetails(id)}
        />
      )}
    </Box>
  );
}

export default StaffDetails;
